import trainDemos from './train-demos'
import trainTickets from './train-tickets'
import trainCell0 from './train-cell0'
import trainAgent from './train-agent'

export default async function (manager) {
    trainDemos(manager)
    trainTickets(manager)
    trainCell0(manager)
    trainAgent(manager)

    return manager.train()
}
